<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import DxButton from 'devextreme-vue/button';
import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';
import { exportDataGrid } from 'devextreme/excel_exporter';
import Loader from "../components/loader";
import CustomStore from 'devextreme/data/custom_store';
import api from "@/axios";


import {
  DxDataGrid,
  DxColumn,
  DxColumnChooser,
  DxColumnFixing,
  DxExport,
  DxStateStoring,
  DxGroupPanel, DxGrouping,
  DxPager, DxFilterRow, DxRemoteOperations
} from 'devextreme-vue/data-grid';
import Swal from "sweetalert2";
import moment from "moment";
import {getBaseUrl} from "@/helpers/baseUrl";



export default {


  components: { Layout, PageHeader, DxButton,
    DxDataGrid, DxColumn, DxColumnChooser, DxColumnFixing, DxExport,
    DxStateStoring, DxGroupPanel, DxGrouping, DxToolbar, DxItem, DxPager,  DxFilterRow, DxRemoteOperations,
    Loader,

  },
  data() {

    return {
      title: "Base Cotação Fretes TRT TDA",
      items: [
        {
          text: "Administrativo",
          href: "/"
        },
        {
          text: "Base Cotação Fretes TRT TDA",
          active: true
        }
      ],
      dataList: null,
      totalList: 0,
      updating: false,
      showModalBaseTrtTda: false,
      submittedBaseTrtTda: false,
      baseTrtTdaData: {},
      errosValid: null,
      focusedRowKey: null,
      freteCotaBaseBasesData: null,
      freteCotaBaseBaseData: {},
      dtListPesqBase: null,
      submittedBase: false,
      inserindoAssocBase: false

    };
  },

  created() {

  },

  computed: {
    dataGrid: function() {
      return this.$refs.dataGridRefKey.instance
    }
  },

  mounted() {
    console.log('mounted mov-list_0')
    this.atualizaDataList()
  },

  methods: {

    pesqBase(evt){
      console.log('pesqBase')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/fretecotabasepesq`, {
          params: { q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqBase = res.data
        })
      }
    },

    novaBaseBase(){
      console.log('novaBaseBase')
      this.inserindoAssocBase = true


    },


    onRowDblClickBase(row){
      console.log('onRowDblClickBase')
      this.freteCotaBaseBaseData = row.data
      this.showModalBaseTrtTda = false


      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Associação de Base",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/fretecotabasetrttdabs`, {
            params: {
              'iddata': this.freteCotaBaseBaseData.id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })

    },


    excluirBaseTrtTda(){
      console.log('excluirBaseTrtTda')
      console.log(this.focusedRowKey)
      // console.log('deletar: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/fretecotabasetrttda`, {
            params: {
              'iddata': this.focusedRowKey
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            //this.atualizaDataList()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
            this.atualizaDataList()
          })
        }
      })
    },


    novaBaseTrtTda(){
      console.log('novaBaseTrtTda')
      this.baseTrtTdaData = {}
      this.submittedBaseTrtTda = false
      this.showModalBaseTrtTda = true
    },


    confBaseTrtTda(){
      console.log('confBaseTrtTda')
      this.submittedBaseTrtTda = true

      if (this.baseTrtTdaData.destino && this.baseTrtTdaData.estado && this.baseTrtTdaData.cepini && this.baseTrtTdaData.cepfim) {
        this.showModalBaseTrtTda = false
        api.post(`${getBaseUrl()}api/fretecotabasetrttda`, {
          freteCotaBaseTrtTda: this.baseTrtTdaData,
          freteCotaBaseBase: this.freteCotaBaseBaseData
        }).then((res) => {
          console.log('res post ocorfinal')
          console.log(res)

          this.atualizaDataList()

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informação salva com sucesso",
            showConfirmButton: false,
            timer: 1500
          })
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
        })
      }

    },


    carregouGrid(e){
      console.log('carregouGrid')
      this.title = '(' + e.component.totalCount() + ') Bases Cotação Fretes TRT TDA'
    },


    atualizaDataList(){
      console.log('atualizaDataList_mov')
      console.log(this.exibEmit)


      this.dataList = new CustomStore({
        key: "id",
        load: function(loadOptions){


          let queryArray = []
          if (loadOptions['filter']) {
            if (loadOptions['filter'][1] === 'and' || loadOptions['filter'][1] === 'or') {
              loadOptions['filter'].forEach((value) => {
                // console.log('value_filter')
                // console.log(value)
                // console.log(value[0])
                // console.log(typeof (value))
                if (typeof (value) === "object") {
                  queryArray.push({
                    cmp: value[0],
                    opr: value[1],
                    val: value[2],
                  })
                }
              })
            } else {
              queryArray.push({
                cmp: loadOptions['filter'][0],
                opr: loadOptions['filter'][1],
                val: loadOptions['filter'][2],
              })
            }
          }
          const paramsReq = {
            'skip': loadOptions['skip'],
            'take': loadOptions['take'],
            'filter': queryArray,
            'sort': loadOptions['sort'],
          }

          console.log('paramsReq')
          console.log(paramsReq)

          return api.get(`${getBaseUrl()}api/fretecotabasestrttda`, {
            params: paramsReq
          }).then(response => {
            console.log('response.data')
            console.log(response)
            return {
              data: response.data[0],
              totalCount: response.data[1],
            }
          })
        },
      })
    },


    onRowDblClick(row) {
      console.log('onRowDblClick')
      // console.log(row.data)
      this.baseTrtTdaData = row.data

      this.inserindoAssocBase = false
      this.freteCotaBaseBaseData = {}
      this.showModalBaseTrtTda = true

      // api.get(`${getBaseUrl()}api/fretecotabasetrttdabs`, {
      //   params: { iddata: this.baseTrtTdaData.id }
      // }).then((res) => {
      //   console.log('then axios')
      //   console.log(res.data)
      //   //console.log(res.data.length)
      //   this.freteCotaBaseBasesData = res.data[1]
      // })
    },

    onCellPrepared(e) {
      if (e.rowType === "data") {
        if (e.column.dataField === "status") {
          // console.log('onCellPrepared')
          // console.log(e.data.status)
          const valStatus = e.data.status
          let corStatus = 'rgba(78,59,0,0.5)'
          switch (valStatus) {
            case 'A':
              corStatus = 'rgba(33,78,0,0.5)'
              break
            case 'I':
              corStatus = 'rgba(146,20,0,0.5)'
              break
          }
          e.cellElement.style.cssText = `color: white; background-color: ${corStatus}`;
        }
      }
    },


    onExporting(e){
      console.log('onExporting')
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('plan1');
      exportDataGrid({
        component: e.component,
        worksheet,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(new Blob([buffer], { type: 'application/octet-stream' }), this.title + '.xlsx');
        });
      });
      e.cancel = true;
    },

    refeFormTable(){
      console.log('refeFormTable')
      this.dataGrid.state(null);

    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    nomeCanal(e) {
      switch (e.value) {
        case 'PU':
          return 'Pusher'

      }
      return 'Não Definido'
    },



    nomeStatus(e) {
      if (e.value === "A") {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },

  },



};

</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <div>

      <DxToolbar>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="refresh"
              hint="Redefinir formatação de tabela para padrão"
              :on-click="refeFormTable"/>
        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="plus"
              hint="Importar arquivo de movimento"
              text="Nova Base"
              :on-click="novaBaseTrtTda"/>

        </DxItem>

        <DxItem
            location="before"
            widget="dxButton">
          <DxButton
              icon="trash"
              hint="Excluir Base"
              text="Excluir Base"
              :on-click="excluirBaseTrtTda"/>
        </DxItem>




      </DxToolbar>

    </div>

    <Loader v-if="updating" style="min-height: 300px;">
    </Loader>


    <div class="mt-2" v-if="!updating">



      <DxDataGrid
          ref="dataGridRefKey"
          :data-source="dataList"
          :show-borders="true"
          :focused-row-enabled="true"
          v-model:focused-row-key="focusedRowKey"
          :column-auto-width="true"
          :show-row-lines="true"
          :allow-column-reordering="true"
          :allow-column-resizing="true"
          :row-alternation-enabled="true"
          @cell-prepared="onCellPrepared"
          @row-dbl-click="onRowDblClick"
          @content-ready="carregouGrid"
          @exporting="onExporting">

        <DxRemoteOperations
            :filtering="true"
            :paging="true"
            :sorting="true"
            :summary="true"
            :grouping="false"
            :group-paging="false"
        />


        <DxColumnChooser :enabled="true"/>
        <DxColumnFixing :enabled="true"/>
        <DxFilterRow :visible="true" />



        <DxExport
            :enabled="true"
            :allow-export-selected-data="true"/>
        <DxStateStoring
            :enabled="true"
            type="sessionStorage"
            storage-key="strOcorFinalsList"/>

        <DxGroupPanel :visible="true"/>
        <DxGrouping />

        <DxColumn
            data-field="id"
            sort-order="desc"
            caption="ID"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="destino"
            caption="Destino"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="estado"
            caption="Estado"
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="cepini"
            caption="CEP Ini."
            data-type="text"
            alignment="left"
            :filter-operations="['contains', 'notcontains', 'startswith', 'endswith', '=', '<>']"
            :allowHeaderFiltering="true"/>

        <DxColumn
            data-field="trtperc"
            caption="TRT(%)"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="trtmin"
            caption="TRT Mín."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="trtmax"
            caption="TRT Máx."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="trtfixo"
            caption="TRT Fixo"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdaperc"
            caption="TDA(%)"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdamin"
            caption="TDA Mín."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdamax"
            caption="TDA Máx."
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>

        <DxColumn
            data-field="tdafixo"
            caption="TDA Fixo"
            data-type="number"
            alignment="right"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="false"/>


        <DxColumn
            data-field="created_at"
            caption="Criado"
            alignment="right"
            data-type="datetime"
            :filter-operations="['=', '<>', '<', '>', '<=', '>=']"
            :allowHeaderFiltering="true"/>


        <DxPager
            :visible="true"
            :show-page-size-selector="true"
            :allowed-page-sizes="[10, 30, 50, 100]"
            :show-navigation-buttons="true"
            :show-info="true"/>


      </DxDataGrid>


    </div>


    <b-modal size="lg"
             :title="baseTrtTdaData.id > 0 ? `Editando Base TRT/TDA (${ baseTrtTdaData.id })` : 'Criando nova Base TRT TDA'"
             v-model="showModalBaseTrtTda" centered hide-footer>
      <div>

        <div class="card-body">
          <div class="row mb-3">

            <div class="col-md-3">
              <label for="destino">Destino</label>
              <div class="position-relative">
                <input
                    id="destino"
                    type="text"
                    v-model="baseTrtTdaData.destino"
                    class="form-control"
                    placeholder="Destino"
                    :class="{'is-invalid': submittedBaseTrtTda && !baseTrtTdaData.destino}"/>
                <div v-if="submittedBaseTrtTda && !baseTrtTdaData.destino" class="invalid-feedback">
                  <span>Campo destino obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-sm-3">
              <div class="mb-3">
                <label for="estado">Estado</label>
                <select
                    id="estado"
                    v-model="baseTrtTdaData.estado"
                    class="form-control"
                    :class="{'is-invalid': submittedBaseTrtTda && !baseTrtTdaData.estado}">
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="DF">Distrito Federal</option>
                </select>
                <div v-if="submittedBaseTrtTda && !baseTrtTdaData.estado" class="invalid-feedback">
                  <span>Campo estado obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>


            <div class="col-md-3">
              <label for="cepini">CEP Início</label>
              <div class="position-relative">
                <input
                    id="cepini"
                    type="text"
                    v-model="baseTrtTdaData.cepini"
                    class="form-control"
                    placeholder="CEP Início"
                    :class="{'is-invalid': submittedBaseTrtTda && !baseTrtTdaData.cepini}"/>
                <div v-if="submittedBaseTrtTda && !baseTrtTdaData.cepini" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-3">
              <label for="cepfim">CEP Final</label>
              <div class="position-relative">
                <input
                    id="cepfim"
                    type="text"
                    v-model="baseTrtTdaData.cepfim"
                    class="form-control"
                    placeholder="CEP Final"
                    :class="{'is-invalid': submittedBaseTrtTda && !baseTrtTdaData.cepfim}"/>
                <div v-if="submittedBaseTrtTda && !baseTrtTdaData.cepfim" class="invalid-feedback">
                  <span>Campo CEP Início obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="trtperc">TRT(%)</label>
              <div class="position-relative">
                <input
                    id="trtperc"
                    type="number"
                    v-model="baseTrtTdaData.trtperc"
                    class="form-control text-end"
                    placeholder="TRT(%)"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtmin">TRT Vlr.Mín.</label>
              <div class="position-relative">
                <input
                    id="trtmin"
                    type="number"
                    v-model="baseTrtTdaData.trtmin"
                    class="form-control text-end"
                    placeholder="TRT Vlr.Mín."/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtmax">TRT Vlr.Máx.</label>
              <div class="position-relative">
                <input
                    id="trtmax"
                    type="number"
                    v-model="baseTrtTdaData.trtmax"
                    class="form-control text-end"
                    placeholder="TRT Vlr.Máx."/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="trtfixo">TRT Vlr.Fixo</label>
              <div class="position-relative">
                <input
                    id="trtfixo"
                    type="number"
                    v-model="baseTrtTdaData.trtfixo"
                    class="form-control text-end"
                    placeholder="TRT Vlr.Fixo"/>
              </div>
            </div>

          </div>

          <div class="row mb-3">

            <div class="col-md-3">
              <label for="tdaperc">TDA(%)</label>
              <div class="position-relative">
                <input
                    id="tdaperc"
                    type="number"
                    v-model="baseTrtTdaData.tdaperc"
                    class="form-control text-end"
                    placeholder="TDA(%)"/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdamin">TDA Vlr.Mín.</label>
              <div class="position-relative">
                <input
                    id="tdamin"
                    type="number"
                    v-model="baseTrtTdaData.tdamin"
                    class="form-control text-end"
                    placeholder="TDA Vlr.Mín."/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdamax">TDA Vlr.Máx.</label>
              <div class="position-relative">
                <input
                    id="tdamax"
                    type="number"
                    v-model="baseTrtTdaData.tdamax"
                    class="form-control text-end"
                    placeholder="TDA Vlr.Máx."/>
              </div>
            </div>

            <div class="col-md-3">
              <label for="tdafixo">TDA Vlr.Fixo</label>
              <div class="position-relative">
                <input
                    id="tdafixo"
                    type="number"
                    v-model="baseTrtTdaData.tdafixo"
                    class="form-control text-end"
                    placeholder="TDA Vlr.Fixo"/>
              </div>
            </div>

          </div>








        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalBaseTrtTda = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>

          <b-button type="submit" variant="success" class="ms-1" @click="confBaseTrtTda">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>



  </Layout>
</template>
